import './App.css';
import { BrowserRouter,Routes, Route } from "react-router-dom";
import AdminPage from './components/admin';
import HomePage from './components/home';
import CollectionPage from './components/collection';

function App() {
  return (
    <BrowserRouter>
    
   <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/admin" element={<AdminPage />} />
      <Route path="/collection" element={<CollectionPage/>}/>
    </Routes>
    </BrowserRouter>
  );
}

export default App;
